import React from 'react';
import { useRouteMatch } from 'react-router-dom';

import { FulfillmentPlanLoader } from './fulfillment-plan-loader';
import { Overview } from '../overview';
import { ReturnLoader } from './return-loader';
import { useFulfillmentPlanIdContext } from '../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useReturnIdContext } from '../context/return-id-context-provider';
import EnhancedReturnLoader from './enhanced-return-loader';
import { useShowOrderOverview } from '../hooks/use-show-order-overview';
import { OrderDetailsRoute } from '../routing';
import { ORDER_DETAILS_ENHANCED_RETURN_PATH_SEGMENT } from '../../../routes/constants';

import style from './order-details-selected-content-container.module.less';

export const OrderDetailsSelectedContentContainer = () => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const returnFulfillmentId = useReturnIdContext();
  const showOverview = useShowOrderOverview();

  const match = useRouteMatch(OrderDetailsRoute);
  const entityType = match?.params?.entityType;
  const isEnhancedReturn = entityType === ORDER_DETAILS_ENHANCED_RETURN_PATH_SEGMENT;
  const ReturnLoaderComponent = isEnhancedReturn ? EnhancedReturnLoader : ReturnLoader;

  if (!fulfillmentPlanId && !returnFulfillmentId) {
    return null;
  }
  if (showOverview) {
    return <Overview fulfillmentPlanId={fulfillmentPlanId} />;
  }

  return (
    <div className={style['order-details-selected-content-background']}>
      <div className={style['order-details-selected-content-container']}>
        {fulfillmentPlanId ? (
          <FulfillmentPlanLoader fulfillmentPlanId={fulfillmentPlanId} />
        ) : (
          <ReturnLoaderComponent returnFulfillmentId={returnFulfillmentId} />
        )}
      </div>
    </div>
  );
};
